import React, { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../../commons/buttons/CustomMUIButton';
import { useTimer } from '../../../../../hooks/useTimer';
import { FormInputText } from '../../../../inputs/FormInputText';
import { TextButton } from '../../../../commons/buttons/TextButton';
import { ButtonClassNames } from '../../../../../models/Common';

interface ConfirmationBySmsCodeFormProps {
  handleBack: () => void;
  handleCodeSubmit: () => void;
  textElement: JSX.Element;
  firstBtnLabel: string;
  inputPlaceholder?: string;
  timerMessage?: string | null;
  handleResend: () => void;
}

const defaultProps = {
  inputPlaceholder: 'briz@briz.ua',
  timerMessage: null,
};

export const ConfirmationByEmailForm: FC<ConfirmationBySmsCodeFormProps> = ({
  handleBack,
  handleCodeSubmit,
  textElement,
  firstBtnLabel,
  inputPlaceholder,
  timerMessage,
  handleResend,
}) => {
  const { t } = useTranslation();
  const methods = useForm();
  const { handleSubmit } = methods;
  const { timer, startTimer, resetTimer } = useTimer(60);

  useEffect(() => {
    startTimer();
  }, []);

  const handleResendCode = () => {
    resetTimer();
    handleResend();
  };

  return (
    <FormProvider {...methods}>
      {textElement}
      <div className="confirmation-email-form">
        <FormInputText name="email" label={inputPlaceholder || defaultProps.inputPlaceholder} className="primary" />
        <div className="confirmation-email-form__btn-group">
          <CustomMUIButton
            label={firstBtnLabel}
            handleClick={handleBack}
            className={ButtonClassNames.SecondaryOutlined}
            isBold
          />
          <CustomMUIButton
            label={t('buttons.continue')}
            handleClick={handleSubmit(handleCodeSubmit)}
            className={ButtonClassNames.PrimaryFulfilled}
            isBold
          />
        </div>
        {timerMessage ? (
          <TextButton
            label={timer > 0 ? `${t('auth.sendAgain')} (${timer})` : t('auth.sendAgain')}
            handleClick={handleResendCode}
            className="primary"
            isArrow={false}
            isDisabled={timer !== 0}
          />
        ) : null}
      </div>
    </FormProvider>
  );
};

ConfirmationByEmailForm.defaultProps = defaultProps;
